import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';

import { findDuplicateAccountGroups } from '../../../../utils';

import { ACCOUNT_GROUPS } from 'RestAPIs/endpoints';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';

import schema from '../../../../create/schema';
import { TabProps } from '../../types';
import GeneralFormFields from './GeneralFormFields';

const General: React.FC<TabProps> = ({
  setIsNavigationDisabled,
  rows,
  toggleInnerLayout,
  currentViewData,
  setCurrentViewData,
  setIsDirty
}) => {
  const { mutateAsync: save } = useUpdateResource({
    id: currentViewData.groupId,
    url: ACCOUNT_GROUPS,
    invalidateQueryKey: 'account-groups'
  });

  const methods = useForm({
    defaultValues: schema.cast(currentViewData),
    resolver: yupResolver(schema)
  });

  const handleSubmit = (dataToSave) => {
    if (findDuplicateAccountGroups(dataToSave, rows) !== -1) {
      methods.setError('name', {
        type: 'unique violation',
        message: 'Unique violation'
      });
      return Promise.reject();
    }

    return save(dataToSave);
  };

  return (
    <GeneralFormFields
      setIsNavigationDisabled={setIsNavigationDisabled}
      toggleInnerLayout={toggleInnerLayout}
      rowData={currentViewData}
      rows={rows}
      methods={methods}
      onSubmit={handleSubmit}
      currentViewData={currentViewData}
      setCurrentViewData={setCurrentViewData}
      setIsDirty={setIsDirty}
    />
  );
};

export default General;
